export default __webpack_public_path__ + "static/media/MediosOutlinedIcon.f7d1abce.svg";